import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardSyncComponent } from './dashboard-sync/dashboard-sync.component';
import { DatavisualizationRoutingModule } from './datavisualization-routing.module'; // Importar el archivo de routing
import { HttpClientModule } from '@angular/common/http';



@NgModule({
  declarations: [
    DashboardSyncComponent
  ],
  imports: [
    CommonModule,
    HttpClientModule,
    DatavisualizationRoutingModule 
  ],
  exports: [DashboardSyncComponent]
})
export class DatavisualizationModule { }
